import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";
import { useLang } from "@/lib/i18n";

const T = {
  fr: {
    seoTitle: "Contact — Maison Partita",
    seoDesc: "Écris à la maison. Nous répondons à chaque message.",
    kicker: "Contact",
    title: "Écris à la maison",
    name: "Ton nom", email: "Ton adresse e-mail", message: "Ton message",
    send: "Envoyer",
  },
  en: {
    seoTitle: "Contact — Maison Partita",
    seoDesc: "Write to the house. We answer every message.",
    kicker: "Contact",
    title: "Write to the house",
    name: "Your name", email: "Your e-mail address", message: "Your message",
    send: "Send",
  },
};

export default function Contact() {
  const lang = useLang();
  const t = T[lang];
  useSeo(t.seoTitle, t.seoDesc);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-2xl mx-auto px-5 sm:px-10 pt-28 pb-32">
      <Reveal>
        <p className="text-[13px] tracking-[0.34em] uppercase text-zinc-500">{t.kicker}</p>
        <h1 className="mt-6 text-4xl sm:text-5xl tracking-[0.08em] text-zinc-50">{t.title}</h1>
        <form onSubmit={submit} className="mt-14 space-y-10" data-testid="contact-form">
          <input required value={form.name} onChange={set("name")} placeholder={t.name}
            className="val-input" data-testid="contact-name" />
          <input type="email" required value={form.email} onChange={set("email")} placeholder={t.email}
            className="val-input" data-testid="contact-email" />
          <textarea required rows={5} value={form.message} onChange={set("message")} placeholder={t.message}
            className="val-input resize-none" data-testid="contact-message" />
          <button type="submit" disabled={busy} className="val-btn" data-testid="contact-submit">
            {busy ? "…" : t.send}
          </button>
        </form>
      </Reveal>
    </section>
  );
}
